// extracted by mini-css-extract-plugin
export default {"body":"cEIpA","list":"tCN2t","item":"S4Mev"};